import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Code } from 'gatsby-theme-docz/src/components/Code';
import { Column } from 'simple-flexbox';
import CollapsibleContent from 'react-collapsible-content';
import ToggleButtonComponent from './common/ToggleButtonComponent';
import TextComponent from './common/TextComponent';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "unmount-on-collapse"
    }}>{`Unmount On Collapse`}</h1>
    <p>{`In case you need to unmount the content when it's collapsed.`}</p>
    <Playground __position={0} __code={'() => {\n  const [expanded, setExpanded] = React.useState(false)\n  const transitioningRef = React.useRef(false)\n  const [transitionStatus, setTransitionStatus] = React.useState(\n    \'has not yet started\',\n  )\n  const isMounted = expanded || transitioningRef.current\n  return (\n    <Column>\n      <div style={{ marginBottom: 10 }}>\n        <div>\n          Transition status: <b>{transitionStatus}</b>\n          <br />\n          Is mounted? <b>{isMounted ? \'Yes\' : \'No\'}</b>\n        </div>\n      </div>\n      <Column style={{ maxWidth: 600, width: \'100%\' }}>\n        <ToggleButtonComponent\n          expanded={expanded}\n          onClick={() => {\n            transitioningRef.current = true\n            setExpanded(prev => !prev)\n          }}\n        />\n        <CollapsibleContent\n          expanded={expanded}\n          onTransitionStart={() => setTransitionStatus(\'has started\')}\n          onTransitionEnd={() => {\n            transitioningRef.current = false\n            setTransitionStatus(\'is over\')\n          }}\n        >\n          {isMounted ? <TextComponent /> : <div></div>}\n        </CollapsibleContent>\n      </Column>\n    </Column>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Code,
      Column,
      CollapsibleContent,
      ToggleButtonComponent,
      TextComponent,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const [expanded, setExpanded] = React.useState(false);
        const transitioningRef = React.useRef(false);
        const [transitionStatus, setTransitionStatus] = React.useState('has not yet started');
        const isMounted = expanded || transitioningRef.current;
        return <Column mdxType="Column">
                <div style={{
            marginBottom: 10
          }}>
                    <div>
                        Transition status:{' '} <b>{transitionStatus}</b>
                        <br />
                        Is mounted?{' '} <b>{isMounted ? 'Yes' : 'No'}</b>
                    </div>
                </div>
                <Column style={{
            maxWidth: 600,
            width: '100%'
          }} mdxType="Column">
                    <ToggleButtonComponent expanded={expanded} onClick={() => {
              transitioningRef.current = true;
              setExpanded(prev => !prev);
            }} mdxType="ToggleButtonComponent" />
                    <CollapsibleContent expanded={expanded} onTransitionStart={() => setTransitionStatus('has started')} onTransitionEnd={() => {
              transitioningRef.current = false;
              setTransitionStatus('is over');
            }} mdxType="CollapsibleContent">
                        {isMounted ? <TextComponent mdxType="TextComponent" /> : <div></div>}
                    </CollapsibleContent>
                </Column>
            </Column>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      